export const SEARCH_QUERY_KEY = 's';
export const SEARCH_QUERY_CATEGORY_KEY = 'category'; // for true and false values
export const SEARCH_PARTNERS_QUERY_KEY = 'partners';
export const FILTER_DIRECTORY_QUERY_KEY = 'role';
export const FILTER_PARTNERS_QUERY_KEY = 'type';

export const SEARCH_CATEGORIES = {
  GALLERY: 'gallery',
  FAQ: 'faq',
  TOOLKIT: 'toolkits',
  ANNOUNCEMENTS: 'announcements',
  CLIENTS: 'clients',
  PARTNERS: 'partners',
  DIRECTORY: 'directory',
} as const;

export type SearchCategoriesType = (typeof SEARCH_CATEGORIES)[keyof typeof SEARCH_CATEGORIES];
